const VALUE_TYPE = 'value' as const;
const CATEGORY_TYPE = 'category' as const;
const ALIGN_RIGHT = 'right' as const;

export const formatAxis = (
  axisData: (string | number)[],
  isHorizontal: boolean = false
) =>
  isHorizontal
    ? {
        xAxis: {
          type: VALUE_TYPE,
        },
        yAxis: {
          type: CATEGORY_TYPE,
          data: axisData,
        },
      }
    : {
        xAxis: {
          type: CATEGORY_TYPE,
          data: axisData,
          axisLabel: {
            interval: 0,
            rotate: 45,
            margin: 10,
            align: ALIGN_RIGHT,
          },
        },
        yAxis: {
          type: VALUE_TYPE,
        },
      };
